import { createColumnHelper } from '@tanstack/react-table';

import { ClusterRole } from '../types';

export const columnHelper = createColumnHelper<ClusterRole>();
